import { useState, useEffect } from 'react'
import { useFetch } from './useFetch'

// For applications and categories
export default function useSingleItemHook(url) {
  const [item, setItems] = useState({})
  const [spinner, setSpinner] = useState(false)
  const [, getItems] = useFetch()

  const loadItem = async () => {
    setSpinner(true)
    const response = await getItems(url)
    setItems(response)
    setSpinner(false)
  }

  useEffect(() => {
    loadItem()
  }, [])

  return [{ item, spinner }]
}
